import CarouselBanner from './CarouselBanner';

export default CarouselBanner;
